<template>
  <el-form class="demo-ruleForm">
   <!-- 选择租客 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.chooseTenant')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="tenantListVisible"
      width="600px"
      style="margin-top: -50px"
    >
    <el-form ref="form" label-width="80px">
      <el-form-item
        :label="$t('apartmentRoomDetail.tenantName')"
        style="margin-top: -15px"
      >
        <el-input v-model="tenantSelectForm.tenantName" style="width:200px" placeholder=""></el-input>
        <el-button type="primary" @click="onSelectTenant">{{
          $t("apartmentRoomDetail.qurey")
        }}</el-button>
      </el-form-item>
      
      <el-table
        ref="tenantList"
        :data="tenantPageData.tenantList"
        highlight-current-row
        @current-change="handleCurrentChangeDetail"
        height="280px"
        style="margin-top: -10px"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          property="tenantName"
          :label="$t('apartmentRoomDetail.tenantName')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="tenantPhone"
          :label="$t('apartmentRoomDetail.tenantPhone')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="tenantEmail"
          :label="$t('apartmentRoomDetail.tenantEmail')"
        ></el-table-column>
        <el-table-column
          property="fingerType"
          label="指纹类型"
        >
         <template slot-scope="scope">
             {{scope.row.fingerType==0?"未定义":scope.row.fingerType==1?"左手拇指":scope.row.fingerType==2?"左手食指":scope.row.fingerType==3?"左手中指":scope.row.fingerType==4?"左手无名指":scope.row.fingerType==5?"左手尾指":
             scope.row.fingerType==6?"右手拇指":scope.row.fingerType==7?"右手食指":scope.row.fingerType==8?"右手中指":scope.row.fingerType==9?"右手无名指":scope.row.fingerType==10?"右手尾指":""}}
          </template>  
        </el-table-column>
        <el-table-column
          property="fingerprintName"
          label="指纹呢称"
        ></el-table-column>
        <el-table-column
          property="status"
          label="状态"
        ></el-table-column>
      </el-table>

      <div style="margin-top: 10px">
        <Pagings
          :total="tenantPageData.total"
          :offset="tenantPageData.offset"
          :pageSize="tenantPageData.pageNumber"
          @handleSizeChangeSub="tenantHandleSizeChange"
          @handleCurrentChangeSub="tenantHandleCurrentChange"
        ></Pagings>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="confirmChooseTenant">{{
          $t("apartmentRoomDetail.confirmChoose")
        }}</el-button>
        <el-button
          type="primary"
          @click="
            tenantListVisible = false;
            checkInVisible = true;
          "
          >{{ $t("apartmentRoomDetail.cancel") }}</el-button
        >
      </div>
    </el-form> 
    </el-dialog>
  <!-- 门锁授权 -->
  <el-dialog
      :title="$t('deviceDetail.lockAuth')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addLockVisible"
      width="650px"
      style="margin-top:-50px"
    >
      <el-form
        :inline="true"
        :model="formTenant"
        ref="formTenant"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('deviceDetail.authName')"
          label-width="130px"
          prop="authName"
          :rules="[{ required: true, message:$t('deviceDetail.authName-input')}]"
          style="margin-top:-15px"
        >
          <el-input
            type="text"
            v-model="formTenant.authName"
            maxlength="16"
            show-word-limit
            :placeholder="$t('deviceDetail.authName')"
            style="width:200px"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('deviceDetail.authType')" label-width="130px" prop="mobile" style="margin-top:-10px">
          <el-col style="width:400px">
             <el-radio
              v-model="formTenant.validType"
              label="0"
              >{{$t('deviceDetail.userPassword')}}</el-radio>
            <el-radio
              v-model="formTenant.validType"
              label="1"
              v-show="deviceType == 1||deviceType==3||deviceType==5 || deviceType==6"
              >{{$t('deviceDetail.userCard')}}</el-radio
            >
            <el-radio 
            v-show="deviceType == 4" 
            v-model="formTenant.validType" 
            label="4">{{$t('deviceDetail.bleKey')}}</el-radio>

            <el-radio 
            v-show="deviceType == 1||deviceType==3||deviceType==5 || deviceType==6"
            v-model="formTenant.validType" 
            label="3">用户指纹</el-radio>

           <!-- <el-radio 
            v-model="formTenant.validType" 
            label="0"
            >{{$t('deviceDetail.offlinePassword')}}</el-radio> -->

           
          </el-col>
        </el-form-item>
        <el-form-item
          :label="$t('update.userType')"
          label-width="130px"
          prop="mobile"
          v-show="formTenant.validType == '1' || formTenant.validType == '0'"
          style="width:400px;margin-top:-10px"
        >
          <!-- <el-radio v-model="formTenant.userType" label="0">{{$t('deviceDetail.admin')}}</el-radio> -->
          <el-radio v-model="formTenant.userType" label="1" v-show="deviceType == 1||deviceType==3||deviceType==5||deviceType==6">{{$t('deviceDetail.consumer')}}</el-radio>
          <el-radio v-model="formTenant.userType" label="2" v-show="formTenant.validType == '0'">{{$t('deviceDetail.tempUser')}}</el-radio>
        </el-form-item>
  
         <el-form-item
          label=" "
          label-width="130px"
          prop=""
          v-show="formTenant.userType == '1'"
          style="width:500px;margin-top:-15px"
        >
          <el-radio v-model="formTenant.limit" label="0">{{$t('deviceDetail.dateless')}}</el-radio>
          <el-radio v-model="formTenant.limit" label="1">{{$t('deviceDetail.limited')}}</el-radio>
        </el-form-item>
       
        <el-row v-show="formTenant.validType=='0'&&formTenant.userType == '2'">
          <el-form-item :label="$t('deviceDetail.authContent')" label-width="130px" prop="mobile" >
            <el-radio v-model="formTenant.passwordType" label="0">{{$t('deviceDetail.tempPassword')}}</el-radio>
            <el-radio v-model="formTenant.passwordType" label="1">{{$t('deviceDetail.timeOffPassword')}}</el-radio>
            <el-radio v-model="formTenant.passwordType" label="2">{{$t('deviceDetail.endDatePassword')}}</el-radio>
          </el-form-item>
          <!-- 截止日期 模式-->
          <el-row v-show="this.formTenant.passwordType == '1'">
            <el-form-item :label="$t('deviceDetail.cutDate')" label-width="130px" prop="cutDate">
              <el-date-picker
                type="date"
                :placeholder="$t('deviceDetail.chooseDate')"
                v-model="formTenant.cutDate"
                style="width:150px"
                align="right"
                :picker-options="pickerOptions"
              ></el-date-picker>
              :
              <el-time-select
               v-model="formTenant.cutTime1"
               :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30'
               }"
               style="width:120px"
               :placeholder="$t('deviceDetail.chooseTime')">
              </el-time-select>
              -
              <el-time-select
               v-model="formTenant.cutTime2"
               :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30'
               }"
               style="width:120px"
               :placeholder="$t('deviceDetail.chooseTime')">
              </el-time-select>
            </el-form-item>
          </el-row>
        </el-row>
        <!-- 开始日期 -->
        <el-row v-show="(this.formTenant.userType=='2'&&this.formTenant.passwordType == '2')||(this.formTenant.limit=='1'&& this.formTenant.userType=='1')">
          <el-form-item :label="$t('deviceDetail.beginDate')" label-width="130px" prop="date1">
            <el-date-picker
              type="date"
              :placeholder="$t('deviceDetail.chooseDate')"
              v-model="formTenant.date1"
              @change="beginDateChange"
              style="width:150px"
            ></el-date-picker>
            -
            <el-time-select
               v-model="formTenant.time1"
               :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30'
               }"
               style="width:120px"
               :placeholder="$t('deviceDetail.chooseTime')">
            </el-time-select>
          </el-form-item>
          <!-- 结束日期 -->
          <el-form-item v-show="this.formTenant.passwordType == '2'||(this.formTenant.limit=='1'&& this.formTenant.userType=='1')" 
          :label="$t('deviceDetail.endDate')" 
          label-width="130px" 
          prop="date2"
          >
            <el-date-picker
              type="date"
              :placeholder="$t('deviceDetail.chooseDate')"
              v-model="formTenant.date2"
              :picker-options="pickerOptionsEnd"
              @change="endDateChange"
              unlink-panels
              style="width:150px"
            ></el-date-picker>
            -
            <el-time-select
               v-model="formTenant.time2"
               :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30'
               }"
               style="width:120px"
               :placeholder="$t('deviceDetail.chooseTime')">
            </el-time-select>

            <el-radio-group v-model="dateRadio" @change="dateChange"  size="small">
              <el-radio-button :label="0" value="0">{{$t('deviceDetail.day')}}</el-radio-button>
              <el-radio-button :label="1" value="2">{{$t('deviceDetail.month')}}</el-radio-button>
              <el-radio-button :label="2" value="4">{{$t('deviceDetail.year')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-row>
        
        <el-form-item
          :label="$t('deviceDetail.authContent')"
          label-width="130px"
          prop="mobile"
          v-show="formTenant.validType == '3'"
        >
          <el-input
            type="text"
            v-model.number="formTenant.fingerprint"
            show-word-limit
            placeholder="请选择指纹用户"
            style="width:150px"
          ></el-input>
          <el-button type="primary" plain icon="el-icon-user" @click="chooseTenant"></el-button>
        </el-form-item>

        <el-form-item
          :label="$t('deviceDetail.authContent')"
          label-width="130px"
          prop="mobile"
          v-show="formTenant.validType == '1'"
        >
          <el-input
            type="text"
            v-model.number="formTenant.card"
            maxlength="16"
            show-word-limit
            :placeholder="$t('deviceDetail.card-input')"
            style="width:150px"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('deviceDetail.password')"
          label-width="130px"
          prop="password"
          v-show="this.formTenant.validType == '0'&&this.formTenant.userType == '1'"
        >
          <el-input
            type="text"
            v-model.number="formTenant.password"
            maxlength="12"
            show-word-limit
            :placeholder="$t('deviceDetail.password-input')"
            style="width:130px"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('deviceDetail.authUser')"
          label-width="130px"
          prop="mobile"
          v-show="formTenant.validType == '4'"
        >
          <el-input
            v-model="formTenant.cloudUser"
            :placeholder="$t('deviceDetail.cloudUser-input')"
            style="width:150px"
          ></el-input>
        </el-form-item>
        <el-row v-show="formTenant.validType == '0'">
          <el-alert
               :title="$t('deviceDetail.password-hint')"
               :closable="false"
               type="warning">
          </el-alert>
        </el-row> 
        <el-form-item style="display:flex;justify-content:center;align-items:center;margin-top:4px">
          <el-button type="primary" @click="addLockAuth">{{$t('deviceDetail.confirm')}}</el-button>
          <el-button type="primary" @click="addLockVisible = false">{{$t('deviceDetail.cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 验证管理员密码 -->
    <el-dialog
      :title="$t('deviceDetail.checkAdmin')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="passwordVisible"
      width="320px"
      style="margin-top:10%"
    >
      <el-form class="demo-ruleForm" ref="adminPassForm">
        <el-form-item :label="$t('deviceDetail.password')" prop="adminPass">
        <el-input type="text" v-model="adminPassForm.adminPass"  :placeholder="$t('deviceDetail.password')" maxlength="18" show-word-limit></el-input>
      </el-form-item> 
      <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="confirmAdminpass()">{{$t('deviceDetail.confirm')}}</el-button>
          <el-button type="primary" @click="passwordVisible = false">{{$t('deviceDetail.cancel')}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
  <!-- 门锁解绑 -->
  <el-dialog
      :title="$t('deviceDetail.unbindType')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="dialogVisible"
      width="320px"
      style="margin-top:10%;"
    >
    <el-button-group style="display:flex;justify-content:center;">
      <el-button type="primary" id="0" @click="netlockUnbind($event)"
        >{{$t('deviceDetail.unbind')}}</el-button
      >
      <el-button type="primary" id="1" @click="netlockUnbind($event)"
        >{{$t('deviceDetail.forceUnbind')}}</el-button
      >
    </el-button-group>
    </el-dialog>

    <el-tabs type="card" ref="tabs" style="min-width:800px;">
      <el-tab-pane :label="$t('deviceDetail.lockInfo')">
        <el-col :span="10" style="border-right:1px #000000 dashed;">
          <el-row>{{$t('deviceDetail.basicInfo')}}</el-row>
          <el-form  label-position="top" label-width="160px" style="padding:10px;">
            <el-form-item :label="$t('deviceDetail.deviceName')" style="width:100%;height:10px">
             {{this.lockDetail.deviceName}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.number')" style="width:100%;height:10px">
              {{this.lockDetail.deviceId}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.bindTime')" style="width:100%;height:10px">
              {{(this.lockDetail.bindTime==""||this.lockDetail.bindTime==undefined)?'':this.$util.formartDateTime(this.lockDetail.bindTime)}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.bindInfo')" style="width:100%;height:10px">
              {{ this.lockDetail.roomName }}{{$t('deviceDetail.room')}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.lockModle')" style="width:100%;height:10px">
              {{this.lockDetail.modelNo}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.supportOpenType')" style="width:100%;height:10px">
              {{this.$util.lockValidTypesFormat(this.lockDetail.validTypes)}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.softwareVersion')" style="width:100%;height:10px">
              {{this.lockDetail.enVersion}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.hardwareVersion')" style="width:100%;height:10px">
              {{this.lockDetail.hardwareVersion}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.supportCMCType')" style="width:100%;height:10px">
              {{this.$util.lockCommTypesFormat(this.lockDetail.commTypes)}}
            </el-form-item>
            <el-form-item :label="$t('deviceDetail.powerType')" style="width:100%;height:10px">
              {{this.$util.lockPowerTypeFormat(this.lockDetail.powerType)}}
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="14" style="padding:3px;">
          <el-form>{{$t('deviceDetail.bo')}}{{this.roomData.deviceType}}</el-form>
          <el-form
            class="demo-ruleForm"
            v-show="this.roomData.deviceType == 1||this.roomData.deviceType == 3||this.roomData.deviceType == 5||this.roomData.deviceType == 6"
          >
           <el-form-item label-width="130px" :label="$t('update.power')" >
               
              <el-col :span="12" style="display:flex;justify-content:center;align-items:center;">
                <el-image v-show="lockDetail.battery<=0&&lockDetail.battery<=10" style="width: 100px; height: 70px" :src="require('@/assets/0pw.jpg')" fit="scale-down"></el-image>
                <el-image v-show="lockDetail.battery>10&&lockDetail.battery<=30" style="width: 100px; height: 70px" :src="require('@/assets/40pw.jpg')" fit="scale-down"></el-image>
                <el-image v-show="lockDetail.battery>30&&lockDetail.battery<=70" style="width: 100px; height: 70px" :src="require('@/assets/60pw.jpg')" fit="scale-down"></el-image>
                <el-image v-show="lockDetail.battery>70&&lockDetail.battery<=90" style="width: 100px; height: 70px" :src="require('@/assets/90pw.jpg')" fit="scale-down"></el-image>
                <el-image v-show="lockDetail.battery>90&&lockDetail.battery<=100" style="width: 100px; height: 70px" :src="require('@/assets/100pw.jpg')" fit="scale-down"></el-image>
              </el-col>
              <el-col :span="12" style="display:flex;justify-content:center;align-items:center;">
                 <div style="margin-top:15px">{{lockDetail.battery}}%</div>
              </el-col>    
            </el-form-item> 
            <el-form-item label-width="130px" :label="$t('deviceDetail.operate')">
              <el-button type="primary" @click="openLock()">{{$t('deviceDetail.remoteOpen')}}</el-button>
            </el-form-item>
            <el-form-item label-width="130px" :label="$t('deviceDetail.lockSet')">
              <el-button-group>
                <el-button type="primary" @click="seeLockTime">{{$t('update.seeLockTime')}}</el-button>
                <el-button type="primary" @click="dialogVisible = true"
                  >{{$t('deviceDetail.unbindLock')}}</el-button
                >
              </el-button-group>
            </el-form-item>
          </el-form>
          <el-form
            class="demo-ruleForm"
            v-show="this.roomData.deviceType == 2"
          >
            <el-form-item label-width="130px" :label="$t('deviceDetail.lockSet')">
              <el-button-group>
                <!-- <el-button type="primary">查看锁码</el-button> -->
                <el-button
                  type="primary"
                  id="0"
                  @click="offlineLockUnbind($event)"
                  >{{$t('deviceDetail.unbindLock')}}</el-button
                >
              </el-button-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-tab-pane>
      <el-tab-pane :label="$t('deviceDetail.authRecord')">
        <div>
          <el-button icon="el-icon-search" @click="onRefresh1">{{$t('deviceDetail.refresh')}}</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddLockAuth">
            {{$t('deviceDetail.addLockAuth')}}
          </el-button>
          <el-form-item :label="$t('deviceDetail.authStatus')" prop="this.authStatus" style="float:right">
           <el-select v-model="authStatus" placeholder="请选择授权状态" @change="authStatusChange">
              <el-option :label="$t('tenant.all')" value=""></el-option>
              <el-option :label="$t('util.start')" value="0"></el-option>
              <el-option :label="$t('util.stop')" value="1"></el-option>
              <el-option :label="$t('util.invalid')" value="2"></el-option>
              <el-option :label="$t('util.delete')" value="3"></el-option>
              <el-option label="待删除" value="4"></el-option>
           </el-select>
          </el-form-item>
        </div>
        <el-table
          :data="authData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
          style="margin-top: 5px"
        >
          <el-table-column
            type="index"
            :label="$t('deviceDetail.order')"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="validType"
            :formatter="this.$util.authValidTypeFormat"
            :label="$t('deviceDetail.authType')"
            align="center"
            width="120"
          ></el-table-column>
           <el-table-column
            prop="authorizationUserId"
            :label="$t('deviceDetail.keyAuthUserId')"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="authorizationName"
            :label="$t('deviceDetail.authName')"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="status"
            :formatter="this.$util.authStatusFormat"
            :label="$t('deviceDetail.authStatus')"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="validData"
            :formatter="this.$util.validDataFormat"
            :label="$t('deviceDetail.authInfo')"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="beginTime"
            :formatter="this.$util.authBeginTimeFormat"
            :label="$t('deviceDetail.beginTime')"
            width="160"
            align="center"
          >
           <template slot-scope="scope">
             {{scope.row.isLimit==1?$util.formartDateTime(scope.row.beginTime):""}}
            </template>
          </el-table-column>
          <el-table-column
            prop="endTime"
            :formatter="this.$util.datetimeFormat"
            :label="$t('deviceDetail.endTime')"
            width="160"
            align="center"
          >
           <template slot-scope="scope">
             {{scope.row.isLimit==1?$util.formartDateTime(scope.row.endTime):""}}
            </template>
          </el-table-column>
          <el-table-column
            prop="validData"
            :formatter="this.$util.timeoffFormat"
            :label="$t('deviceDetail.timeOff')"
             width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            :formatter="this.$util.datetimeFormat"
            :label="$t('deviceDetail.createTime')"
            align="center"
            width="160"
          ></el-table-column>
          <el-table-column prop :label="$t('deviceDetail.operate')" width="100px" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" icon="el-icon-delete" :title="$t('deviceDetail.delete')" @click="delAuth(scope.$index, scope.row)"></el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <Pagings
          :total="authTotal"
          :offset="authPageData.offset"
          :pageSize="authPageData.pageNumber"
          @handleSizeChangeSub="authHandleSizeChange"
          @handleCurrentChangeSub="authHandleCurrentChange"
          style="margin-top: 10px"
        ></Pagings>
      </el-tab-pane>

      <el-tab-pane :label="$t('deviceDetail.record')">
        <el-row>
          <el-col :span="4">
            <el-button icon="el-icon-search" @click="onRefresh2">{{$t('deviceDetail.refresh')}}</el-button>
          </el-col>
          <el-col :span="6">
            <download-excel :data="json_data" :fields="json_fields" name="OPENRECORD.xls" >
              <el-button icon="el-icon-document">Export Excel</el-button>
            </download-excel>
          </el-col>
          <el-col :span="14">
            <el-radio-group v-model="selectMonths" @change="radioChange" style="float:right">
              <el-radio-button label="1">One Month</el-radio-button>
              <el-radio-button label="3">Three Month</el-radio-button>
            </el-radio-group>
          </el-col>   
        </el-row>
        <el-table
          :data="openRecordData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
          style="margin-top: 5px"
        >
          <el-table-column
            type="index"
            :label="$t('deviceDetail.order')"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="operateUserId"
            :label="$t('deviceDetail.keyAuthUserId')"
            align="center"
          >
          <template slot-scope="scope">
              <!-- validType 0:密码 1:门卡 2:身份证 3指纹 4蓝牙 -->
              {{scope.row.validType==1||scope.row.validType==4?scope.row.operateUserId:scope.row.authorizationUserId}}
           </template>
          </el-table-column>
          <el-table-column
            prop="authorizationName"
            :label="$t('deviceDetail.authName')"
            align="center"
          >
           <template slot-scope="scope">
              <!-- validType 0:密码 1:门卡 2:身份证 3指纹 4蓝牙 -->
              {{scope.row.validType==1||scope.row.validType==4?scope.row.operateUserName:scope.row.authorizationName}}
           </template>
          </el-table-column>
          <el-table-column
            prop="deviceId"
            :label="$t('deviceDetail.lockId')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="openTime"
            :formatter="this.$util.datetimeFormat"
            :label="$t('deviceDetail.openTime')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="validType"
            :formatter="this.$util.validTypeFormat"
            :label="$t('deviceDetail.openType')"
            align="center"
          ></el-table-column>
        </el-table>
        <Pagings
          :total="openTotal"
          :offset="openPageData.offset"
          :pageSize="openPageData.pageNumber"
          @handleSizeChangeSub="openRecordHandleSizeChange"
          @handleCurrentChangeSub="openRecordHandleCurrentChange"
          style="margin-top: 10px"
        ></Pagings>
      </el-tab-pane>
      <el-tab-pane :label="$t('deviceDetail.aleamLog')">
        <div style="margin-bottom: 5px">
          <el-button icon="el-icon-search" @click="onRefresh3">{{$t('deviceDetail.refresh')}}</el-button>
        </div>
        <el-table
          :data="alarmData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
        >
          <el-table-column
            type="index"
            :label="$t('deviceDetail.order')"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="alarmMessage"
            :label="$t('deviceDetail.aleamRemark')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="alarmType"
            :label="$t('deviceDetail.aleamType')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('deviceDetail.aleamTime')"
            :formatter="this.$util.datetimeFormat"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deviceId"
            :label="$t('deviceDetail.deviceId')"
            align="center"
          ></el-table-column>
        </el-table>
        <Pagings
          :total="alarmTotal"
          :offset="alarmPageData.offset"
          :pageSize="alarmPageData.pageNumber"
          @handleSizeChangeSub="alarmHandleSizeChange"
          @handleCurrentChangeSub="alarmHandleCurrentChange"
          style="margin-top: 10px"
        ></Pagings>
      </el-tab-pane>
    </el-tabs>
  </el-form>
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "deviceDetail", //这个LoginName最好和引入的vue的LoginName相同
  props: ["infoData", "roomData", "tabIndex", "sonTabsItem"],
  data() {
    return {
      tenantListVisible:false,
      tenantPageData:{
        offset: 1,
        pageNumber: 10,
        total: 0, //总条数
        tenantList:[]
      },
      currentTenantRow:"",
      tenantSelectForm:{
        tenantName:"" 
      },
      authStatus:'',
      selectMonths:'1',
      json_fields: {
        'Authorization ID': 'authorizationID',
        'Authorization Name': 'authorizationName',
        'Device ID': 'deviceId',
        'Open Time':'openTime',
        'Open door verification method':'validType'
      },
      json_data: [
           
      ],
      addLockVisible: false,
      dialogVisible: false,
      passwordVisible: false,
      authPageData: {
        offset: 1,
        pageNumber: 10
      },
      openPageData: {
        offset: 1,
        pageNumber: 10
      },
      alarmPageData: {
        offset: 1,
        pageNumber: 10
      },
      authTotal: 1, //总条数
      openTotal: 1, //总条数
      alarmTotal: 1, //总条数
      authData: [],
      openRecordData: [],
      alarmData: [],
      lockDetail: [],
      adminPassForm: {
        adminPass: ""
      },
      deviceId: "",
      deviceType: "",
      formTenant: {
        authName: "",
        validType: "",
        passwordType: "0",
        userType: "",
        password: "",
        card: "",
        cloudUser:"",
        date1: new Date(),
        time1: this.$util.formatHalfTime(new Date()),
        date2: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        time2: this.$util.formatHalfTime(new Date()),
        cutDate: new Date(new Date().getTime()),
        cutTime1: this.$util.formatHalfTime(new Date()),
        cutTime2: this.$util.formatHalfTime(new Date(new Date().getTime() +2*60 * 60 * 1000)),
        limit:"1",//0无限期，1有效期
        fingerprint:""
      },
      pickerOptionsEnd:{
          disabledDate: this.disabledDate,
      },
      pickerOptions: {
          disabledDate(time) {
            var date=new Date();
            date=date.setFullYear(date.getFullYear()+1);
            return time.getTime()>= new Date(date).getTime();
          },
          shortcuts: [
          {text: this.$t('deviceDetail.7Day'),onClick(picker) {
                  const date = new Date();
                  date.setTime(date.getTime() +7*3600 * 1000 * 24);
                  picker.$emit('pick', date);
               }
          },
          {text: this.$t('deviceDetail.10Day'),onClick(picker) {
                  const date = new Date();
                  date.setTime(date.getTime() +10*3600 * 1000 * 24);
                  picker.$emit('pick', date);
               }
          },
          {text: this.$t('deviceDetail.15Day'),onClick(picker) {
                  const date = new Date();
                  date.setTime(date.getTime() +15*3600 * 1000 * 24);
                  picker.$emit('pick', date);
               }
          },
          {text: this.$t('deviceDetail.30Day'),onClick(picker) {
                  const date = new Date();
                  date.setTime(date.getTime() + 30*3600 * 1000 * 24);
                  picker.$emit('pick', date);
               }
          },
          {
            text: this.$t('deviceDetail.month1'),
            onClick(picker) {
              // picker.$emit('pick', new Date());
              const date = new Date();
              date.setMonth(date.getMonth()+1);
              picker.$emit('pick', date);
            }
          }, {
            text: this.$t('deviceDetail.month3'),
            onClick(picker) {
             const date = new Date();
              date.setMonth(date.getMonth()+3);
              picker.$emit('pick', date);
            }
          }, {
            text: this.$t('deviceDetail.month6'),
            onClick(picker) {
              const date = new Date();
              date.setMonth(date.getMonth()+6);
              picker.$emit('pick', date);
            }
          },{
            text:this.$t('deviceDetail.month12'),
            onClick(picker) {
              const date = new Date();
              date.setMonth(date.getMonth()+12);
              picker.$emit('pick', date);
            }
          }]
        },
        dateRadio:0//快捷选择日期
    };
  },
  components: {
    Pagings
  },
  watch: {
    tabIndex(val) {
      var sonTabsItem = this.sonTabsItem;
      for (var str in sonTabsItem) {
        if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
          var sonTabItemList = sonTabsItem[str].tabsItem;
          for (var s in sonTabItemList) {
            if (sonTabItemList[s].name == val &&val != 1 &&sonTabItemList[s].type == 1) {
              this.deviceId = sonTabItemList[s].id;
              this.deviceType = sonTabItemList[s].ref.deviceType;
              // this.roomData=sonTabItemList[s].ref;
              this.getLockDetail();
              this.authPower();
              // alert("设备类型"+window.JSON.stringify(sonTabItemList[s].ref.deviceType));

              switch(sonTabItemList[s].ref.deviceType){
                 case 1:
                 case 3://NB联网  
                 case 5://4G联网 
                 case 6://wifi直连   
                   this.formTenant.validType="0";
                   this.formTenant.userType="1";
                   this.openRecordPower(this.selectMonths);
                   this.alarmPower();
                   break 
                 case 2://联网
                    this.formTenant.validType="0";
                    this.formTenant.userType="2";

                   break
                 case 4:
                   this.formTenant.validType="3";
                   this.openRecordPower(this.selectMonths);
                   this.alarmPower();
                   break    
              }
            }
          }
        }
      }
    }
  },
  created() {
    var sonTabsItem = this.sonTabsItem;
    for (var str in sonTabsItem) {
      if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
        var sonTabItemList = sonTabsItem[str].tabsItem;
        for (var s in sonTabItemList) {
          if (sonTabItemList[s].name == this.tabIndex &&this.tabIndex != 1 &&sonTabItemList[s].type == 1) {
            this.deviceId = sonTabItemList[s].id;
            this.deviceType = sonTabItemList[s].ref.deviceType;
            // this.roomData=sonTabItemList[s].ref;
            // alert(sonTabItemList[s].ref.roomId);
            this.getLockDetail();
            this.authPower();
            // alert("设备类型"+window.JSON.stringify(sonTabItemList[s].ref.deviceType));
            switch(sonTabItemList[s].ref.deviceType){
                case 1:
                case 3:
                case 5: 
                case 6:   
                   this.formTenant.validType="0";
                   this.formTenant.userType="1";
                   this.openRecordPower(this.selectMonths);
                   this.alarmPower();
                   this.exportLockOpenRecord(this.selectMonths);
                   break 
                 case 2:
                    this.formTenant.validType="0";
                    this.formTenant.userType="2";
                   break
                 case 4:
                   this.formTenant.validType="0";
                   this.openRecordPower(this.selectMonths);
                   this.alarmPower();
                   this.exportLockOpenRecord(this.selectMonths);
                   break    
              }
          }
        }
      }
    }
  },
  mounted() {
    this.hideTabs();
    this.tenantPower();
  },
  methods: {
     //确认选择租客
    confirmChooseTenant() {
      if (this.currentTenantRow == "" || this.currentTenantRow == null) {
        this.$message({
          message: this.$t("apartmentRoomDetail.chooseTenant1"),
          type: "warning",
        });
        return false;
      }
      this.tenantListVisible = false;
      this.formTenant.fingerprint=this.currentTenantRow.fingerprintId;
      // this.addFgDevice.tenantName = this.currentTenantRow.tenantName;
      // this.addFgDevice.tenantId = this.currentTenantRow.tenantId;
    },
    //选择租客
    chooseTenant(){
        this.tenantListVisible=true;
    },
    //获得选择租客
    handleCurrentChangeDetail(val){
        this.currentTenantRow=val;
    },
    //查询租客
    onSelectTenant(){
       this.tenantPower();
    },
    //授权状态过滤
    authStatusChange(){
        this.authPower();
    },
    //导出开门记录时间改变事件
    radioChange(){
       this.openRecordPower(this.selectMonths);//重新刷新门锁记录
      this.exportLockOpenRecord(this.selectMonths);//根据月份导出
    },
    //查看门锁
    seeLockTime(){
        var formData = new FormData();
        formData.append("deviceId", this.deviceId);
        formData.append("operationType", 2); //操作类型:1门锁版本，2门锁系统时间
        this.$server
          .exam("/customer/lock/deviceGetInfo", formData)
          .then(data => {
          if (data.code == 200) {
              var rtnData = data["data"];
              // this.addNetLockVisible=false;
              const loading = this.$loading({
                lock: true,
                text: "loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
              var obj = {};
              obj.rId = rtnData;
              obj.loading = loading;
              obj.opType = "seeLockTime";
              this.$store.dispatch("checkResult", obj); //等待回调
           } else {
                this.$message({
                  message: data.message,
                  type: "warning"
                });
            }
        });
    },
    //刷新授权，开门记录，报警记录
    onRefresh1(){
      this.$message({
        message: this.$t('deviceDetail.beRefresh'),
        type: 'success'
      });
      this.authPower();//刷新授权
    },
    onRefresh2(){
       this.$message({
        message:  this.$t('deviceDetail.beRefresh'),
        type: 'success'
      });
       this.openRecordPower(this.selectMonths);//刷新开门记录
    },
    onRefresh3(){
       this.$message({
        message:  this.$t('deviceDetail.beRefresh'),
        type: 'success'
      });
       this.alarmPower();//刷新报警记录
    },
    dateChange(){
        switch(this.dateRadio){
         case 0://日
           this.formTenant.date1=new Date();
           this.formTenant.date2=new Date(new Date(this.formTenant.date1).getTime() + 24 * 60 * 60 * 1000);
           break;
         case 1://月
           var date =new Date();
           date.setMonth(date.getMonth()+1);
           this.formTenant.date2=new Date(date);
           this.formTenant.date1=new Date();
           break;
         case 2://年
           var date =new Date();
           date.setFullYear(date.getFullYear()+1);
           this.formTenant.date2=new Date(date);
           this.formTenant.date1=new Date();
           break;        
       }
    },
    //禁用日期段时间控件
    disabledDate(time) {
      var date=new Date(this.formTenant.date1);
      date=date.setFullYear(date.getFullYear()+1);
      return time.getTime() > new Date(date).getTime();  
    },
    //结束日期改变事件
    endDateChange(date){
      this.dateRadio='';
    },
    //开始日期改变事件
    beginDateChange(date){
      this.dateRadio='';
      // alert(this.$util.formartDate(date));
      // this.formTenant.date2=this.$util.formartDate(date.getTime()+ 24 * 60 * 60 * 1000);
      // this.pickerOptionsEnd.disabledDate(date);
    },
    //打开门锁授权
    openAddLockAuth(){
      this.addLockVisible=true;
      this.formTenant.authName="";
      this.formTenant.card="";
      this.formTenant.password="";
    },
    //删除授权
    delAuth(index, authData) {
      this.$confirm(this.$t('deviceDetail.deleteAuth-confirm1')+authData.authorizationName+this.$t('deviceDetail.deleteAuth-confirm2'),this.$t('deviceDetail.hint'), {
          confirmButtonText: this.$t('deviceDetail.confirm'),
          cancelButtonText: this.$t('deviceDetail.cancel'),
          type: 'warning'
        }).then(() => {
         var path="";
         var formData = new FormData();
         switch (this.deviceType) {
          case 2: //离线锁
           formData.append("authInfoId", authData.authInfoId);
           path="/customer/apartment/deleteLockAuthorization";
           formData.append("isDelete", 1);
          break;
          case 1: //联网锁
           formData.append("authInfoId", authData.authInfoId);
           path="/customer/apartment/deleteLockAuthorization";
           if(authData.validUser==3){//离线用户（离线密码）
             formData.append("isDelete", 1);
           }else{
             formData.append("isDelete", 0);
           }
          break;
         case 3: //NB联网锁
           formData.append("authInfoId", authData.authInfoId);
           path="/customer/apartment/deleteLockAuthorization";
           if(authData.validUser==3){//离线用户（离线密码）
             formData.append("isDelete", 1);
           }else{
             formData.append("isDelete", 0);
           }
          break;
         case 4://蓝牙锁
           formData.append("authInfoId", authData.authInfoId);
          //  path="/customer/apartment/deleteRoomAuthorization";
           path="/customer/apartment/deleteLockAuthorization";
           formData.append("isDelete", 1);
           break; 
          case 5: //NB联网锁
           formData.append("authInfoId", authData.authInfoId);
           path="/customer/apartment/deleteLockAuthorization";
           if(authData.validUser==3){//离线用户（离线密码）
             formData.append("isDelete", 1);
           }else{
             formData.append("isDelete", 0);
           }
          break;  
          case 6: //wifi直连
           formData.append("authInfoId", authData.authInfoId);
           path="/customer/apartment/deleteLockAuthorization";
           if(authData.validUser==3){//离线用户（离线密码）
             formData.append("isDelete", 1);
           }else{
             formData.append("isDelete", 0);
           }
          break;
         }
         this.$server
          .exam(path, formData)
          .then(data => {
          if (data.code == 200) {
            switch (this.deviceType) {
              case 2://离线锁
                this.$message({
                  message: data.message,
                  type: "success"
                });
                this.authPower();
                break;
              case 3://NB联网锁（和联网锁一样）
              case 5://4G联网锁（和联网锁一样）
              case 6://wifi直连（和联网锁一样）
              case 1://联网锁
                if(authData.validUser==3||(data.data==''||data.data.length==0)){//离线用户（离线密码）
                   this.$message({
                    message: data.message,
                    type: "success"
                  });
                  this.authPower();
                }else{
                  const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                  });
                  var obj = {};
                  obj.rId = data.data[0].recordId;
                  obj.loading = loading;
                  obj.opType = "delNetLockAuth";
                  obj.othis = this;
                  obj.apartmentId = this.infoData.apartmentId;
                  this.$store.dispatch("checkResult", obj); //等待回调
                }
                break;
              case 4://蓝牙锁
                this.$message({
                  message: data.message,
                  type: "success"
                });
                this.authPower();
                break;
              }
           } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
           }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('deviceDetail.cancleDelete')
          });          
        });
    },
    //门锁授权
    addLockAuth() {
      if (this.formTenant.authName == "" || this.formTenant.authName == null) {
        this.$message({
          message: this.$t('deviceDetail.authName-input'),
          type: "warning"
        });
        return false;
      }
      var formData = new FormData();
      formData.append("authorizationName", this.formTenant.authName);
      formData.append("lockId", this.deviceId);
      formData.append("isSendSms", 0);
      //授权类型
      switch (this.formTenant.validType) {
        // case "0": //密码----已经取消
        //   // formData.append("validData", this.formTenant.password);
        //   formData.append("validType", 0);
        //   switch (this.formTenant.passwordType) {//密码类型
        //     case "0": //临时密码
        //       formData.append("validUser", 3);
        //       formData.append("openCount", 1);
        //       this.$server
        //         .exam("/customer/lock/createOfflineTempPass", formData)
        //         .then(data => {
        //           this.addLockVisible = false;
        //           if (data.code == 200) {
        //             this.$message({
        //               message: data.message,
        //               type: "success"
        //             });
        //             this.authPower();
        //           } else {
        //             this.$message({
        //               message: data.message,
        //               type: "warning"
        //             });
        //           }
        //         });
        //       break;
        //     case "1": //时间段密码
        //       formData.append("endDay",this.$util.formartDate(this.formTenant.cutDate));
        //       formData.append("beginTime",this.formTenant.cutTime1+":00");
        //       formData.append("endTime",this.formTenant.cutTime2+":00");
        //       formData.append("validUser", 3);
        //       this.$server
        //         .exam("/customer/lock/createOfflineBetweenTimePass", formData)
        //         .then(data => {
        //           this.addLockVisible = false;
        //           if (data.code == 200) {
        //             this.$message({
        //               message: data.message,
        //               type: "success"
        //             });
        //             this.authPower();
        //           } else {
        //             this.$message({
        //               message: data.message,
        //               type: "warning"
        //             });
        //           }
        //         });
        //       break;
        //     case "2": //结束日期密码
        //       formData.append("beginDatetime",this.$util.formartDate(this.formTenant.date1) +" " +this.formTenant.time1);
        //       formData.append("endDateTime",this.$util.formartDate(this.formTenant.date2) +" " +this.formTenant.time2);
        //       formData.append("validUser", 3);
        //       this.$server
        //         .exam("/customer/lock/createOfflineDatetimePass", formData)
        //         .then(data => {
        //           this.addLockVisible = false;
        //           if (data.code == 200) {
        //             this.$message({
        //               message: data.message,
        //               type: "success"
        //             });
        //             this.authPower();
        //           } else {
        //             this.$message({
        //               message: data.message,
        //               type: "warning"
        //             });
        //           }
        //         });
        //       break;
        //   }
        //   break;
        case "1": //卡片
          if (
            this.formTenant.card == "" ||
            this.formTenant.card == null ||
            this.formTenant.card.length > 15 ||
            this.formTenant.card < 8
          ) {
            this.$message({
              message:this.$t('deviceDetail.cardNo15byte-input'),
              type: "warning"
            });
            return false;
          }
          formData.append("validType", 1);
          formData.append("validData", this.formTenant.card);
          formData.append("isLocked", 0);
          formData.append("isOpen", 0);
          switch (this.formTenant.userType) {
            // case "0": //管理员
            //   formData.append("validUser", 0);
            //   formData.append("isLimit", parseInt(this.formTenant.limit));
            //   break;
            case "1": //普通用户
             
              formData.append("isLimit", parseInt(this.formTenant.limit));
              if(this.formTenant.limit==1){
                formData.append("validUser", 2);
                formData.append("beginTime",this.$util.formartDate(this.formTenant.date1) +" " +this.formTenant.time1+":00");
                formData.append("endTime",this.$util.formartDate(this.formTenant.date2) +" " +this.formTenant.time2+":00");
              }else{
                formData.append("validUser", 1);
              }
              break;
            // case "2": //临时用户
            //   formData.append("validUser", 2);
            //   formData.append("isLimit", parseInt(this.formTenant.limit));
            //   formData.append(
            //     "beginTime",
            //     this.$util.formartDate(this.formTenant.date1) +
            //       " " +
            //       this.formTenant.time1+":00"
            //   );
            //   formData.append(
            //     "endTime",
            //     this.$util.formartDate(this.formTenant.date2) +
            //       " " +
            //       this.formTenant.time2+":00"
            //   );
            //   break;
          }
          this.addLockAuthorization(formData);
          break;
        case "0": //密码
          switch (this.formTenant.userType) {
            // case "0": //管理员
            //   formData.append("validType", 0);
            //   formData.append("validData", this.formTenant.password);
            //   formData.append("isLocked", 0);
            //   formData.append("isOpen", 0);
            //   formData.append("isLimit", 0);
            //   formData.append("validUser", 0);
            //   break;
            case "1": //普通用户
              formData.append("validType", 0);
              if(this.formTenant.password!=""&&this.formTenant.password!=null){
                formData.append("validData", this.formTenant.password);
              }
              formData.append("isLocked", 0);
              formData.append("isOpen", 0);
              formData.append("isLimit", this.formTenant.limit);
              if(this.formTenant.limit==1){
                formData.append("validUser", 2);
                formData.append("beginTime",this.$util.formartDate(this.formTenant.date1) +" " +this.formTenant.time1+":00");
                formData.append("endTime",this.$util.formartDate(this.formTenant.date2) +" " +this.formTenant.time2+":00");
              }else{
                formData.append("validUser", 1);
              }
              this.addLockAuthorization(formData);
              break;
            case "2": //临时用户
              // formData.append("validUser", 2);
              // formData.append("isLimit", 1);
              // formData.append("beginTime",this.$util.formartDate(this.formTenant.date1) +" " +this.formTenant.time1+":00");
              // formData.append("endTime",this.$util.formartDate(this.formTenant.date2) +" " +this.formTenant.time2+":00");
             formData.append("validType", 0);
             switch (this.formTenant.passwordType) {//密码类型
              case "0": //临时密码
               formData.append("validUser", 3);
               formData.append("openCount", 1);
               this.$server
                .exam("/customer/lock/createOfflineTempPass", formData)
                .then(data => {
                  this.addLockVisible = false;
                  if (data.code == 200) {
                    this.$message({
                      message: data.message,
                      type: "success"
                    });
                    this.authPower();
                  } else {
                    this.$message({
                      message: data.message,
                      type: "warning"
                    });
                  }
                });
              break;
             case "1": //时间段密码
              formData.append("endDay",this.$util.formartDate(this.formTenant.cutDate));
              formData.append("beginTime",this.formTenant.cutTime1+":00");
              formData.append("endTime",this.formTenant.cutTime2+":00");
              formData.append("validUser", 3);
              this.$server
                .exam("/customer/lock/createOfflineBetweenTimePass", formData)
                .then(data => {
                  this.addLockVisible = false;
                  if (data.code == 200) {
                    this.$message({
                      message: data.message,
                      type: "success"
                    });
                    this.authPower();
                  } else {
                    this.$message({
                      message: data.message,
                      type: "warning"
                    });
                  }
                });
              break;
             case "2": //结束日期密码
              formData.append("beginDatetime",this.$util.formartDate(this.formTenant.date1) +" " +this.formTenant.time1);
              formData.append("endDateTime",this.$util.formartDate(this.formTenant.date2) +" " +this.formTenant.time2);
              formData.append("validUser", 3);
              this.$server
                .exam("/customer/lock/createOfflineDatetimePass", formData)
                .then(data => {
                  this.addLockVisible = false;
                  if (data.code == 200) {
                    this.$message({
                      message: data.message,
                      type: "success"
                    });
                    this.authPower();
                  } else {
                    this.$message({
                      message: data.message,
                      type: "warning"
                    });
                  }
                });
               break;
              }
            break;
          }
          break;
        case "4": //蓝牙钥匙
          if(this.formTenant.cloudUser=="" || this.formTenant.cloudUser==null){
              this.$message({
                message: this.$t('deviceDetail.mobile-input'),
                type: "warning"
              });
          }
          formData.append("validType", 4);
          formData.append("validData", this.formTenant.cloudUser);
          formData.append("isLocked", 0);
          formData.append("isOpen", 0);
          formData.append("validUser", 2);
          formData.append("isLimit", 1);
          formData.append("beginTime",this.$util.formartDate(this.formTenant.date1) +" " +this.formTenant.time1+":00");
          formData.append("endTime",this.$util.formartDate(this.formTenant.date2) +" " +this.formTenant.time2+":00");
          this.addLockAuthorization(formData);
        case '3'://用户指纹
           var fingerprintId=this.formTenant.fingerprint;
           if(fingerprintId==""||fingerprintId==null){
              this.$message({
                message:"请选择租客指纹",
                type: "warning"
              });
             return false;
           }
           formData.append("validData",fingerprintId);
           formData.append("validType", 3);
           formData.append("isLocked", 0);
           formData.append("isOpen", 0);
           formData.append("isLimit", this.formTenant.limit);
           if(this.formTenant.limit==1){
              formData.append("validUser", 2);
              formData.append("beginTime",this.$util.formartDate(this.formTenant.date1) +" " +this.formTenant.time1+":00");
              formData.append("endTime",this.$util.formartDate(this.formTenant.date2) +" " +this.formTenant.time2+":00");
           }else{
              formData.append("validUser", 1);
           }

          this.addLockAuthorization(formData);
         break;
      }
    },
    addLockAuthorization(data) {
      this.$server
        .exam("/customer/lock/addLockAuthorization", data)
        .then(data => {
          this.addLockVisible = false;
          if (data.code == 200) {
              this.$message({
                 message: data.message,
                  type: "success"
                });
                this.$store.commit("getApartmentDetail", {
                apartmentId: this.infoData.apartmentId
              }); //加载公寓楼栋
              this.authPower();
            // if(this.formTenant.validType==1||this.formTenant.validType==0){
            //    const loading = this.$loading({
            //     lock: true,
            //     text: "Loading",
            //     spinner: "el-icon-loading",
            //     background: "rgba(0, 0, 0, 0.7)"
            //    });
            //    var obj = {};
            //    obj.rId = data.data[0];
            //    obj.loading = loading;
            //    obj.opType = "addNetLockAuth";
            //    obj.othis = this;
            //    obj.apartmentId = this.infoData.apartmentId;
            //    this.$store.dispatch("checkResult", obj); //等待回调
            // }else{
            //     this.$message({
            //      message: data.message,
            //       type: "success"
            //     });
            //     this.$store.commit("getApartmentDetail", {
            //       apartmentId: this.infoData.apartmentId
            //    }); //加载公寓楼栋
            //     this.authPower();
            // }
            
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    //远程开锁
    openLock() {
      var formData = new FormData();
      formData.append("deviceId", this.roomData.deviceId);
      formData.append("operationType", 1); //设备类型：应用网关0，联网门锁1，离线门锁2，NB门锁3
      this.$server
        .exam("/customer/lock/deviceRemoteOperation", formData)
        .then(data => {
          if (data.code == 200) {
            var rtnData = data["data"];
            // this.addNetLockVisible=false;
            const loading = this.$loading({
              lock: true,
              text: this.$t('deviceDetail.openLock'),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            var obj = {};
            obj.rId = rtnData;
            obj.loading = loading;
            obj.opType = "openLock";
            this.$store.dispatch("checkResult", obj); //等待回调
            // this.$mainInfo.removeTab(obj.tabIndex);
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    //联网锁强制删除提交
    confirmAdminpass() {
        var formData = new FormData();
        formData.append("deviceId", this.deviceId);
        formData.append("deviceType", 1); //设备类型：应用网关0，联网门锁1，离线门锁2，NB门锁3
        formData.append("isForceUnbind", 1);
        formData.append("password",this.adminPassForm.adminPass);
        this.$server
          .exam("/customer/apartment/unbindDevice", formData)
          .then(data => {
            if (data.code == 200) {
              var rtnData = data["data"];
              // this.addNetLockVisible=false;
              this.$message({
                message: data.message,
                type: "success"
              });
              this.$store.commit("getApartmentDetail", {
                apartmentId: this.infoData.apartmentId
              }); //加载公寓楼栋
               this.$mainInfo.removeTab(this.tabIndex);
            } else {
              this.$message({
                message: data.message,
                type: "warning"
              });
            }
          });
    },
    //联网锁解绑
    netlockUnbind(e) {
      // this.$confirm('此操作将解除门锁与绑定网关关系, 是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
         var unbindType = e.currentTarget.id;//0正常解绑，1强制解绑
         if (unbindType == "0") {
         var formData = new FormData();
         formData.append("deviceId", this.deviceId);
         formData.append("deviceType", this.roomData.deviceType); //设备类型：应用网关0，联网门锁1，离线门锁2，NB门锁3,蓝牙锁4
         formData.append("isForceUnbind", 0);
         this.$server
          .exam("/customer/apartment/unbindDevice", formData)
          .then(data => {
            if (data.code == 200) {
              var rtnData = data["data"];
              // this.addNetLockVisible=false;
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
              var obj = {};
              obj.apartmentId = this.infoData.apartmentId;
              obj.rId = rtnData;
              obj.loading = loading;
              obj.opType = "unbindNetLock";
              obj.tabIndex = this.tabIndex;
              obj.othis = this;
              this.$store
                .dispatch("checkResult", obj)
                .then(res => {
                  // this.$mainInfo.removeTab(this.tabIndex);
                })
                .catch(err => {
                  console.log(err);
                }); //等待回调
            } else {
              this.$message({
                message: data.message,
                type: "warning"
              });
            }
          });
        } else {
          this.dialogVisible = false;
          this.passwordVisible = true;
        }
    // }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消解除'
    //     });          
    // });
    },
    //离线锁解绑
    offlineLockUnbind(e) {
      this.$confirm(this.$t('deviceDetail.unbindLockRoomHint'), this.$t('deviceDetail.hint'), {
          confirmButtonText: this.$t('deviceDetail.confirm'),
          cancelButtonText: this.$t('deviceDetail.cancel'),
          type: 'warning'
        }).then(() => {
           var formData = new FormData();
          formData.append("deviceId", this.deviceId);
          formData.append("deviceType", 2); //设备类型：应用网关0，联网门锁1，离线门锁2，NB门锁3
          formData.append("isForceUnbind", 0);
          this.$server
          .exam("/customer/apartment/unbindDevice", formData)
          .then(data => {
           if (data.code == 200) {
            this.$message({
              message: data.message,
              type: "success"
            });
            this.$store.commit("getApartmentDetail", {
              apartmentId: this.infoData.apartmentId
            }); //加载公寓楼栋
            this.$mainInfo.removeTab(this.tabIndex);
           } else {
            this.$message({
              message: data.message,
              type: "warning"
             });
           }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message:  this.$t('deviceDetail.cancelUnbind')
          });          
        });
    },
    hideTabs() {
      this.$nextTick(function() {
        switch(this.roomData.deviceType){
          case 1://联网锁
            break;
          case 2://离线锁
            this.$refs.tabs.$children[0].$refs.tabs[2].style.display = "none";
            this.$refs.tabs.$children[0].$refs.tabs[3].style.display = "none";
            break;
          case 3://NB锁
            break;
          case 4://蓝牙锁
            // this.$refs.tabs.$children[0].$refs.tabs[1].style.display = "none";
            this.$refs.tabs.$children[0].$refs.tabs[2].style.display = "none";
            this.$refs.tabs.$children[0].$refs.tabs[3].style.display = "none";
            break;     
          case 5://4G锁
            break;  
          case 6://wifi直连
            break;    
        }
      });
    },
    tenantPower() {
      var formData = new FormData();
      if(this.tenantSelectForm.tenantName != "" &&this.tenantSelectForm.tenantName != null) {
        formData.append("userName", this.tenantSelectForm.tenantName);
      }
      // formData.append("apartmentId", this.infoData.apartmentId);
      formData.append("pageNo", this.tenantPageData.offset);
      formData.append("pageSize", this.tenantPageData.pageNumber);
      this.$server
        .exam("/customer/fingerprint/pageTenantFingerprint", formData)
        .then((data) => {
          if (data.code == 200) {
            this.tenantPageData.tenantList = data.data.records;
            this.tenantPageData.total = data.data.total;
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
     },
    getLockDetail() {
      var formData = new FormData();
      formData.append("deviceId", this.deviceId);
      this.$server
        .exam("/customer/apartment/getLockDetail", formData)
        .then(data => {
          if (data.code == 200) {
            this.lockDetail = data.data;
            // this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    authPower() {
      var formData = new FormData();
      formData.append("deviceId", this.deviceId);
      formData.append("pageNo", this.authPageData.offset);
      formData.append("pageSize", this.authPageData.pageNumber);
      if(this.authStatus!=""){
         formData.append("status",parseInt(this.authStatus));
      }else{
        formData.append("status","");
      }
      this.$server
        .exam("/customer/apartment/listLockAuthorization", formData)
        .then(data => {
          if (data.code == 200) {
            this.authData = data.data.records;
            this.authTotal = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    openRecordPower(months) {
      var formData = new FormData();
      formData.append("deviceId", this.deviceId);
      var beginDate=new Date();
      switch(months){
        case '1'://1个月
          beginDate=beginDate.setMonth(beginDate.getMonth()-1);
          break
        case '3'://3个月
          beginDate=beginDate.setMonth(beginDate.getMonth()-3);
          break  
      }
      formData.append("beginTime",this.$util.formartDateTime(beginDate));
      formData.append("endTime",this.$util.formartDateTime(new Date()));
      formData.append("pageNo", this.openPageData.offset);
      formData.append("pageSize", this.openPageData.pageNumber);
      this.$server
        .exam("/customer/apartment/listLockOpenRecord", formData)
        .then(data => {
          if (data.code == 200) {
            this.openRecordData = data.data.records;
            this.openTotal = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    alarmPower() {
      var formData = new FormData();
      formData.append("deviceId", this.deviceId);
      formData.append("pageNo", this.alarmPageData.offset);
      formData.append("pageSize", this.alarmPageData.pageNumber);
      this.$server
        .exam("/customer/apartment/listDeviceAlarmRecord", formData)
        .then(data => {
          if (data.code == 200) {
            this.alarmData = data.data.records;
            this.alarmTotal = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    
    //根据时间导出开门记录
    exportLockOpenRecord(months){
      var formData = new FormData();
      formData.append("deviceId", this.deviceId);
      var beginDate=new Date();
      switch(months){
        case '1'://1个月
          beginDate=beginDate.setMonth(beginDate.getMonth()-1);
          break
        case '3'://3个月
          beginDate=beginDate.setMonth(beginDate.getMonth()-3);
          break  
      }
      formData.append("beginTime",this.$util.formartDateTime(beginDate));
      formData.append("endTime",this.$util.formartDateTime(new Date()));
      this.$server
        .exam("/customer/apartment/exportLockOpenRecord", formData)
        .then(data => {
          if (data.code == 200) {
           var recordData=data.data;
           this.json_data=[];
           for(var str in recordData){
               var obj={};
               obj.authorizationID=recordData[str].operateUserId;
               obj.authorizationName=recordData[str].operateUserName;
               obj.deviceId="&nbsp;"+recordData[str].deviceId;
               obj.openTime=recordData[str].openTime;
               obj.validType=recordData[str].validType;
               this.json_data.push(obj);
            }
            // console.log(window.JSON.stringify(this.json_data));
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    authHandleSizeChange(val) {
      this.authPageData.pageNumber = val;
      this.authPower();
    },
    authHandleCurrentChange(val) {
      this.authPageData.offset = val;
      this.authPower();
    },

    openRecordHandleSizeChange(val) {
      this.openPageData.pageNumber = val;
      this.openRecordPower(this.selectMonths);
    },
    openRecordHandleCurrentChange(val) {
      this.openPageData.offset = val;
      this.openRecordPower(this.selectMonths);
    },

    alarmHandleSizeChange(val) {
      this.alarmPageData.pageNumber = val;
      this.alarmPower();
    },
    alarmHandleCurrentChange(val) {
      this.alarmPageData.offset = val;
      this.alarmPower();
    },
    tenantHandleSizeChange(val) {
      this.tenantPageData.pageNumber = val;
      this.tenantPower();
    },
    tenantHandleCurrentChange(val) {
      this.tenantPageData.offset = val;
      this.tenantPower();
    }
  }
};
</script>
<style>
 .item{
     text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/device/deviceDetail.vue